<template>
  <div
    style="text-align: right;"
  >
    <el-dropdown
      ref="dropDown"
      size="small"
      @command="handleAction"
    >
      <el-button
        size="mini"
        class="el-dropdown-link"
        @click.stop="toggleDropDown"
      >
        <i :class="!buttonLoader ? 'el-icon-more' : 'el-icon-loading'" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-can="'representativeorder.update'"
          :command="copyRepresentativeOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-document-copy" /> Másolás
        </el-dropdown-item>
        <!--<el-dropdown-item-->
          <!--v-can="'representativeorder.view'"-->
          <!--v-if="representativeOrder.status !== 'recorded' && representativeOrder.status !== 'cancelled' && representativeOrder.receipt_file"-->
          <!--:command="openReceipt"-->
          <!--:disabled="buttonLoader"-->
        <!--&gt;-->
          <!--<i class="el-icon-printer" /> Bizonylat nyomtatása-->
        <!--</el-dropdown-item>-->
        <el-dropdown-item
          v-can="'representativeorder.update'"
          v-if="representativeOrder.status === 'recorded'"
          :command="sendOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-box" /> Küldés a raktárnak
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'representativeorder.update'"
          :command="updateRepresentativeOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-edit" /> Módosítás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="representativeOrder.status === 'recorded'"
          v-can="'representativeorder.delete'"
          :command="openDeleteConfirmation"
          :disabled="buttonLoader"
        >
          <i class="el-icon-delete" /> Törlés
        </el-dropdown-item>
        <el-dropdown-item
          v-if="representativeOrder.status === 'recorded' || representativeOrder.status === 'sent'"
          :command="openResignationConfirmation"
          :disabled="buttonLoader"
        >
          <i class="el-icon-close" /> Lemondás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="representativeOrder.status === 'resigned'"
          :command="openUndoResignationConfirmation"
          :disabled="buttonLoader"
        >
          <i class="el-icon-check" /> Lemondás visszavonása
        </el-dropdown-item>
        <el-dropdown-item
          :command="exportExcel"
          :disabled="buttonLoader"
        >
          <i class="el-icon-download" /> Excel exportálás
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  export default {
    props: ['representativeOrder'],
    data() {
      return {
        buttonLoader: false,
        deleteConfirmVisible: false,
        resignConfirmVisible: false,
      };
    },

    methods: {
      async deleteRrepresentativeOrder() {
        this.buttonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('representativeOrder/delete', this.representativeOrder.id);
          this.$store.dispatch('representativeOrder/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      async resignRepresentativeOrder() {
        this.buttonLoader = true;
        this.resignConfirmVisible = false;

        try {
          await this.$store.dispatch('representativeOrder/resign', this.representativeOrder.id);
          this.$store.dispatch('representativeOrder/fetchAll');
        } catch (e) {}

        this.buttonLoader = false;
      },
      async undoRepresentativeOrderResignation() {
        this.buttonLoader = true;
        this.resignConfirmVisible = false;

        try {
          await this.$store.dispatch('representativeOrder/undoResignation', this.representativeOrder.id);
          this.$store.dispatch('representativeOrder/fetchAll');
        } catch (e) {}

        this.buttonLoader = false;
      },

      async updateRepresentativeOrder() {
        this.$router.push('/sales/representative-orders/update/' + this.representativeOrder.id);
      },
      async sendOrder() {
        this.buttonLoader = true;
        try {
          await this.$store.dispatch('representativeOrder/send', this.representativeOrder.id);
          this.$store.dispatch('representativeOrder/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      openReceipt() {
        if (this.representativeOrder.receipt_file && this.representativeOrder.receipt_file.path) {
          window.open(this.representativeOrder.receipt_file.path);
        }
      },
      openDeleteConfirmation() {
        this.$confirm('Ez a folyamat nem visszafordítható és a kapcsolódó elemek is törölve lesznek.', 'Biztosan törölni szeretnéd?', {
          confirmButtonText: 'Igen',
          cancelButtonText: 'Mégse',
          type: 'warning',
        })
        .then(() => {
          this.deleteRepresentativeOrder();
        })
        .catch(() => {
          this.$router.replace('/sales/representative-orders');
        });
      },
      handleAction(action) {
        action();
      },
      toggleDropDown() {
        this.$refs['dropDown'].visible = !this.$refs['dropDown'].visible;
      },
      copyRepresentativeOrder() {
        this.$router.push('/sales/representative-orders/add/' + this.representativeOrder.id);
      },
      async exportExcel() {
        try {
          this.buttonLoader = true;
          const excel = await axios({
            url: 'api/representative-orders/' + this.representativeOrder.id + '/export',
            method: 'GET',
            responseType: 'blob',
          });
          saveAs(excel, 'representative_order_items.xlsx');
        } catch (e) {
        }
        this.buttonLoader = false;

      },

      openResignationConfirmation() {
        this.$confirm('Amennyiben lemondod a megrendelést, nem fog megjelenni az Árukészlet riportban.', 'Biztosan le szeretnéd mondani?', {
          confirmButtonText: 'Igen',
          cancelButtonText: 'Mégse',
          type: 'warning',
        })
        .then(() => {
          this.resignRepresentativeOrder();
        })
        .catch(() => {
          this.$router.replace('/sales/representative-orders');
        });
      },

      openUndoResignationConfirmation() {
        this.$confirm('Amennyiben visszavonod a lemondását, a megrendelés "Rögzítve" státszba kerül', 'Biztosan visszavonod a lemondást?', {
          confirmButtonText: 'Igen',
          cancelButtonText: 'Mégse',
          type: 'warning',
        })
        .then(() => {
          this.undoRepresentativeOrderResignation();
        })
        .catch(() => {
          this.$router.replace('/sales/representative-orders');
        });
      },
    }
  };
</script>
